const atom = require('recoil').atom;

module.exports = {
  isAmbientListeningActive: atom({
    key: 'isAmbientListeningActive',
    default: false
  }),
  enhanceAmbientListeningLoading: atom({
    key: 'enhanceAmbientListeningLoading',
    default: false
  }),
  ambientListeningIntelligenceChatId: atom({
    key: 'ambientListeningIntelligenceChatId',
    default: null
  }),
  enhancedNote: atom({
    key: 'enhancedNote',
    default: null
  }),
  emCPTsText: atom({
    key: 'emCPTsText',
    default: null
  }),
  currentActiveStepID: atom({
    key: 'currentActiveStepID',
    default: 1
  }),
  transcriptionLoading: atom({
    key: 'transcriptionLoading',
    default: false
  }),
  isTranscriptionCreated: atom({
    key: 'isTranscriptionCreated',
    default: null
  }),
  transcriptions: atom({
    key: 'transcriptions',
    default: []
  }),
  selectedNoteType: atom({
    key: 'selectedAmbientListeningNoteType',
    default: null
  }),
  preSelectedNoteType: atom({
    key: 'preSelectedAmbientListeningNoteType',
    default: null
  }),
  additionalProviderNotesState: atom({
    key: 'additionalProviderNotesState',
    default: ''
  })
};
